// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let ButtonsV5 = require("./ButtonsV5.bs.js");
let JsxRuntime = require("react/jsx-runtime");

function ConversationsSection__SendMessageButtons$SendPublicMessageButton(props) {
  let onSubmit = props.onSubmit;
  return JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
    onClick: param => onSubmit(),
    disabled: props.submitDisabled,
    children: "Send a new public message"
  });
}

let SendPublicMessageButton = {
  make: ConversationsSection__SendMessageButtons$SendPublicMessageButton
};

function ConversationsSection__SendMessageButtons$SendPrivateMessageButton(props) {
  let onSubmit = props.onSubmit;
  return JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
    onClick: param => onSubmit(),
    disabled: props.submitDisabled,
    children: "Send private message"
  });
}

let SendPrivateMessageButton = {
  make: ConversationsSection__SendMessageButtons$SendPrivateMessageButton
};

let Buttons;

exports.Buttons = Buttons;
exports.SendPublicMessageButton = SendPublicMessageButton;
exports.SendPrivateMessageButton = SendPrivateMessageButton;
/* ButtonsV5 Not a pure module */
